import {combineReducers} from "redux";
import FilterReducer from "../FilterReducer";
import TabReducer from "../TabReducer";
import LoginReducer from "../LoginReducer";
import viewPowerBiReducer from '../PowerBiReducer';

const RootReducer= combineReducers({
    filter:FilterReducer,
    tabs:TabReducer,
    login:LoginReducer,
    viewPowerBi: viewPowerBiReducer,
});

export default RootReducer;
